<template>
  <div>
    <template v-if="loading">
      <place-full-loading />
    </template>
    <template v-else-if="genreId == 'TH6_tag168'">
      <place-cycle :place="placeFull" />
    </template>
    <template v-else-if="genreId == 'TH6_tag163'">
      <place-tolocca :place="placeFull" />
    </template>
    <template v-else-if="genreId == 'TH6_tag167'">
      <place-busstop :place="placeFull" />
    </template>
    <template v-else-if="genreId == 'carshare'">
      <place-carshare :place="placeFull" />
    </template>
    <template v-else-if="place.isGooglePlace">
      <place-google-place :place="place" />
    </template>
    <template v-else>
      <place-poi :place="placeFull">
        <slot></slot>
      </place-poi>
    </template>
  </div>
</template>

<script>
import PlacePoi from './PlacePoi'
import PlaceCycle from './PlaceCycle'
import PlaceTolocca from './PlaceTolocca'
import PlaceBusstop from './PlaceBusstop'
import PlaceCarshare from './PlaceCarshare'
import PlaceGooglePlace from './PlaceGooglePlace'
import PlaceFullLoading from './PlaceFullLoading'

import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  components: {
    PlacePoi,
    PlaceCycle,
    PlaceTolocca,
    PlaceBusstop,
    PlaceCarshare,
    PlaceGooglePlace,
    PlaceFullLoading
  },
  data () {
    return {
      loading: false
    }
  },
  created () {
    this.updateDetail(this.place)
  },
  methods: {
    updateDetail: function (newPlace) {
      if (!_.isEmpty(newPlace) && !newPlace.isGooglePlace) {
        this.loading = true
        this.$store.dispatch('places/fetchPlace', newPlace.id)
          .finally(() => {
            this.loading = false
          })
      }
    }
  },
  computed: {
    ...mapGetters({
      placeFull: 'places/getPlaceFull'
    }),
    genreId: function () {
      return this.place.genreIds && this.place.genreIds[0]
    }
  },
  watch: {
    place: function (newPlace) {
      this.updateDetail(newPlace)
    }
  }
}
</script>
